<template>
    <main id="mainCtrl">
        <NetworkEditDialog ref="networkEditDialog" />
        <NetworkNotFound ref="networkNotFound"/>
        <header v-if="canCreate">
            <button @click="create">
                <img width="25" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAMCSURBVGhD7ZrPq01RFMdvfoVI4ulJGSmljIhCvYmUxEzJmJGJkqGZlBkD/gIKY97AG75kgAnqTRj4FZJfISQ/vt+tVfutu9be55x7rnOee771qbfP2uvc/X1377X3Oe/1Os3WAXAHfAe/C/IGXAHrQCt0CFgDLcpzsAo0rqeAAzoCFvBCQa0GNwFzz/JCkxoDHMjL0CqvHYD5t0OrQa0HHMiT0OrXfLASLA+tfm0GzL8fWg0qZ0QGOh1a/eqMlNESwGlhsQJQlhGZTmQnYJxrQK7F00wbWQikn8c8UEj7wUPwE/BDLGTglhEZnEf87Wgj+4Dur/kEroK1wNVe8Asw4TN45yAfbBnZBKTfR8D4j+jaJBBpI3uA9PPgvZgzAxYDU3cBOx0PrbyaWCOcXpyqzDvGC5Z4xPgGOM+LqKnFfhQw70JoGWLww98fCylnZCN4DDinLVU1chgw72JoGarbSE6tMcLDHnNeh1Z5bQPMvxdaxVW7EeoRYN5JwLOXrvse/DZvgOSAHA3FCPed1J6TgwdO/gLKaChGqAlwC7wFVu23eAUugSoPVkMz8q81mkYWgS0ZWD5j8aBp9dPwGBOLh1CrX8wGICplRPaIFHr/kH0hh943ihwWrwNRJSOsSNydY54BxjwjPNjpHPICMO4Z+Qp0DvcoxgY2Yq0ZGbBnxNvpdwHGPSPWmUwG3Rn574zwAWu3Qo7RnhHOa51D+JzDuGfkAdA5ZwBjAxtJ4RnJ4RlJUdnIOOATY4r45hRrvdVPw3e+sTjlrH4x54ColJE2azSNLAUHM3Bux1oG9GK12Api8dWOdf8YTj9Raxa7LrNDXexihMeNKYW8jvGM8CWaziH8YxDjnpH3QOewJDM2sBFrzXgbn1zX5VUkG6JnpHU7e2cktGarNiNfgK4gJwBjdRvh+1z9WecBYwMbSVG3kRSVjawBuoJoLoNYVY1sB9b9Y04DUSkjVVTVSFmNlhFrcRclLgJW/BRg3FrUZZACkDQyl3CNXJtj8L8tOnXqlFWv9wdHqNUHI3he9gAAAABJRU5ErkJggg==">
                Добавить сеть клиник
            </button>
        </header>

        <v-table id="table"
                 request-uri="networks/getList"
                 pagesize="50"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="city" sort="city" width="45">
                        Город
                    </v-th>
                    <v-th name="created_at" sort="created_at" width="70">
                        Создана
                    </v-th>
                    <v-th name="img" width="50">
                        Лого
                    </v-th>
                    <v-th name="name" minwidth="120" sort="name">
                        Сеть клиник
                    </v-th>
                    <v-th name="clinic" minwidth="120">
                        Клиники
                    </v-th>
                    <v-th name="registryPhone" sort="registryPhone" width="115">
                        Тел клиники
                    </v-th>
                    <v-th name="clinicPhone" sort="phone" width="115">
                        Тел Doctu.ru
                    </v-th>
                    <v-th name="reportOn" sort="reportOn" width="30" tooltip="Автоматическая отправка отчетов">
                       АО
                    </v-th>
                    <v-th name="url" sort="url" minwidth="100" >
                        URL
                    </v-th>
                    <v-th name="proprietary" sort="proprietary" width="50" tooltip="Форма собственности">
                        ФС
                    </v-th>
                    <v-th name="website" sort="website" minwidth="100" >
                        Сайт
                    </v-th>
                    <v-th name="subscriptionTariff" width="100">
                        Тариф
                    </v-th>
                    <v-th name="subscriptionActivity" width="75">
                        Период
                    </v-th>
                    <v-th name="subscriptionDuration" width="35" tooltip="Длительность">
                        Дл
                    </v-th>
                    <v-th name="subscriptionPrice" width="50">
                        Цена
                    </v-th>
                    <v-th name="dateOfNotificationLkClose" width="70" tooltip="Дата уведомления о закрытии ЛК">
                        <i class="fas fa-lock"></i>
                    </v-th>
                    <v-th name="created_by" width="50">
                        Созд
                    </v-th>
                    <v-th name="networkDescription" width="40" v-tooltip="'Описание'">
                        Опис
                    </v-th>
                </v-tr>

                <v-tr>
                    <v-th name="city" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...cityOptions
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="created_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="img" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'Есть', value: 'ANY' },
                                  { text: 'Нет', value: 'MISSING'},
                                ]">

                        </v-select>
                    </v-th>

                    <v-th name="name" :debounce="true" minwidth="120" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="clinic" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>

                    <v-th name="registryPhone" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="clinicPhone" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>

                    <v-th class="fa-hack" name="reportOn" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "1",
                                    text: " Да"
                                },
                                {
                                    value: "0",
                                    text: "Нет"
                                }
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="url" minwidth="100" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>

                    <v-th name="proprietary" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "private",
                                    text: "Час"
                                },
                                {
                                    value: "municipal",
                                    text: "Гос"
                                },
                                {
                                    value: "multi",
                                    text: "Мульти"
                                },
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="website" minwidth="100" v-slot="{filter}">
                        <v-input :vBeautify="striptagsTrimNoHttp" v-model="filter.value"/>
                    </v-th>

                    <v-th name="subscriptionTariff" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "*",
                                    text: "* Любой"
                                },
                                {
                                    value: "-",
                                    text: "- Без тарифа"
                                },
                                {
                                    value: "ONLY_LK",
                                    text: "Личный кабинет сети"
                                },
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="subscriptionActivity" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                   value: "ended15DaysAgo",
                                   text: "Завершился до 15 дней назад"
                                },
                                                        {
                                   value: "ended30DaysAgo",
                                   text: "Завершился до 30 дней назад"
                                },
                                {
                                    value: "active",
                                    text: "Активна сейчас"
                                },
                                {
                                    value: "endsIn15Days",
                                    text: "Закончится в течение 15 дней"
                                },
                                {
                                    value: "endsIn30Days",
                                    text: "Закончится в течение 30 дней"
                                },
                                {
                                    value: "endsIn3060Days",
                                    text: "Закончится через 30-60 дней"
                                },
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="subscriptionDuration" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "*",
                                    text: "* Любой"
                                },
                                {
                                    value: "-",
                                    text: "- Нет"
                                },
                                {
                                    value: "30",
                                    text: "до 30"
                                },
                                {
                                    value: "30|89",
                                    text: "30-89"
                                },
                                {
                                    value: "90|179",
                                    text: "90-179"
                                },
                                {
                                    value: "180|359",
                                    text: "180-359"
                                },
                                {
                                    value: "360",
                                    text: "от 360"
                                },
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="subscriptionPrice" v-slot="{filter}">
                        <v-input v-model="filter.value" highlight="*" />
                    </v-th>

                    <v-th name="dateOfNotificationLkClose" width="70" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'Уведомили', value: 'NOTIFIED' },
                                  { text: 'Не уведомили', value: 'NOT_NOTIFIED'},
                                  { text: 'Этот месяц', value: 'THIS_MONTH'},
                                  { text: 'Прошлый месяц', value: 'PREV_MONTH'},
                                ]">

                        </v-select>
                    </v-th>

                    <v-th name="created_by" width="50" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...managerOptions
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="networkDescription" width="40" v-slot="{filter}">
                        <v-select v-model="filter.value"
                            :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'Есть', value: 'ANY' },
                                  { text: 'Нет', value: 'MISSING'},
                                ]">

                        </v-select>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr :class="['hover', 'pointer']"
                      @click="(row, event) => handleRowClick(event, row, item)">

                    <v-td name="city" highlight="*" width="45">
                        <span v-if="item.cityObj !== null" v-tooltip="item.cityObj.name">{{ item.cityObj.name_info.short }}</span>
                    </v-td>

                    <v-td name="created_at" highlight="*" width="70">
                        {{ item.created_at | formatDateWithShortYearAndMonth }}
                    </v-td>

                    <v-td name="img" width="50">
                        <img v-if="Object.keys(item.img).length" width="40" :src="item.img.little" alt="">
                    </v-td>

                    <v-td name="name" minwidth="120">
                        <div><b>{{ item.name }}</b></div>
                    </v-td>

                    <v-td name="clinic" minwidth="120">
                        <div v-for="clinic in item.clinics">{{clinic.name}}</div>
                    </v-td>

                    <v-td name="registryPhone" width="115">
                        {{ item.registryPhone.replace('+', '') }}
                    </v-td>

                    <v-td name="clinicPhone" width="115">
                        {{ item.phone.replace('+', '') }}
                    </v-td>
                    <v-td name="reportOn" highlight="*" width="30">
                        <template v-if="item.reportOn">
                            <i class="fa fa-check text-success" v-tooltip="`${item.reportToName}<br/>${item.reportTo}<br/>${item.reportCc}`"></i>
                        </template>
                    </v-td>
                    <v-td name="url" minwidth="100">
                        <a class="text-ellipsis" v-if="item.proprietary==='private'"
                            v-tooltip="`${$parent.frontendUrl}<br/>/${item.cityObj.char_id}/net/${item.url}`"
                            @click.prevent.stop="openHref(`${$parent.frontendUrl}/${item.cityObj.char_id}/net/${item.url}`)"
                            :href="`${$parent.frontendUrl}/${item.cityObj.char_id}/net/${item.url}`"
                            target="_blank">
                            {{ item.url }}
                        </a>
                        <span v-else>
                             {{ item.url }}
                        </span>
                    </v-td>
                    <v-td name="proprietary" width="50">
                        <template v-if="item.proprietary === 'private'">Час</template>
                        <template v-if="item.proprietary === 'municipal'">Гос</template>
                        <template v-if="item.proprietary === 'multi'">Мульт</template>
                    </v-td>
                    <v-td name="website" minwidth="100">
                        <a
                            @click.prevent.stop="openHref(getWebsiteUrl(item.website))"
                            :href="getWebsiteUrl(item.website)" target="_blank"
                        >{{ item.website }}</a>
                        <a v-if="item.socialVk !== null && item.socialVk.length > 1"
                           :href="'http://' + item.socialVk"
                           @click.prevent.stop="openHref('http://' + item.socialVk)"
                        >
                            <br>
                            {{ item.socialVk }}
                            <br>
                        </a>
                        <a v-if="item.socialOk !== null && item.socialOk.length > 1"
                           :href="'http://' + item.socialOk"
                           @click.prevent.stop="openHref('http://' + item.socialOk)"
                        >
                            {{item.socialOk}}
                            <br/>
                        </a>
                        <a v-if="item.socialYoutube !== null && item.socialYoutube.length > 1"
                           :href="'http://' + item.socialYoutube"
                           @click.prevent.stop="openHref('http://' + item.socialYoutube)"
                        >
                            {{item.socialYoutube}}
                            <br/>
                        </a>
                        <a v-if="item.socialTg !== null && item.socialTg.length > 1"
                           :href="'http://' + item.socialTg"
                           @click.prevent.stop="openHref('http://' + item.socialTg)"
                        >
                            {{item.socialTg}}
                            <br/>
                        </a>
                        <a v-if="item.socialWhatsApp !== null && item.socialWhatsApp.length > 1"
                           :href="'http://wa.me/' + item.socialWhatsApp"
                           @click.prevent.stop="openHref('http://wa.me/' + item.socialWhatsApp)"
                        >
                            {{item.socialWhatsApp}}
                            <br/>
                        </a>
                    </v-td>
                    <v-td name="subscriptionTariff" highlight="*"  width="100" >
                        <template v-if="item.subscription">
                            <span v-if="item.subscription.tariff === 'ONLY_LK'">Личный кабинет сети</span>
                        </template>
                    </v-td>
                    <v-td name="subscriptionActivity" highlight="*" width="75">
                        <template v-if="item.subscription">
                            {{ item.subscription.dateFrom | formatDatePeriodShort(item.subscription.dateTill) }}
                        </template>
                    </v-td>
                    <v-td name="subscriptionDuration" highlight="*" width="35">
                        <template v-if="item.subscription">
                            {{ item.subscription.duration }}
                        </template>
                    </v-td>
                    <v-td name="subscriptionPrice" width="50">
                        <template v-if="item.subscription">
                            {{ item.subscription.price }}
                        </template>
                    </v-td>
                    <v-td name="dateOfNotificationLkClose" width="70">
                        <template v-if="item.dateOfNotificationLkClose">
                            {{ item.dateOfNotificationLkClose | formatDateWithShortYearAndMonth }}
                        </template>
                        <template v-else>-</template>
                    </v-td>
                    <v-td name="created_by">
                        <span>{{ item.createdBy === null ? '—' : item.createdBy.fioInitials }}</span>
                    </v-td>
                    <v-td name="networkDescription" width="40">
                        <div v-if="item.description">+</div>
                        <span v-else>нет</span>
                    </v-td>

                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import NetworkEditDialog from "@dialogs/admin/networks/networkEdit/Dialog";
import NetworkNotFound from "@dialogs/NetworkNotFound";

export default {
    components: {
        NetworkEditDialog,
        NetworkNotFound
    },

    props: {
        cityOptions: { type: Array, required: true },
        managerOptions: { type: Array, required: true },
    },

    mounted: function () {
        this.checkIncomingNetwork();
        this.$refs.table.update();
    },

    methods: {
        clearWHash () {
            window.location.hash = '';
        },
        checkIncomingNetwork () {
            let url = this.$root.getQueryVariable('url');
            if (url !== null && url.length > 1) {
                this.axios.get('networks/getShortInfo/' + url, {}).then(response => {
                    if (response.data.status === 'OK') {
                        this.$refs.networkEditDialog.read(response.data.data.id);
                    } else if (response.data.data.network_status !== undefined) {
                        this.$refs.networkNotFound.show(response.data.data.network_status);
                    }
                });

            }
        },
        create: function () {
            this.$refs.networkEditDialog.create();
        },
        handleRowClick: function (event, row, item) {
            row.startLoadingAnimation();
            return this.readNetwork(item.id, event, row);
        },
        readNetwork: function (networkId, e, row) {
            console.log('readNetwork',networkId)
            this.$refs.networkEditDialog
                .read(networkId)
                .then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());
        },
        openHref(href) {
            window.open(href)
        },
        getWebsiteUrl(website) {
            return website.indexOf('http') !== -1 ? website : 'http://' + website;
        }
    },

    computed: {
        striptagsTrimNoHttp () {
            return "striptags trim nohttp";
        },
        canEdit () {
            return this.$canAny(['admin.networks.update'])
        },
        canCreate () {
            return this.$canAny(['admin.networks.create'])
        },
    }
}
</script>
